import { useMutation } from "@tanstack/react-query";
import { useEffect, useState, useCallback } from "react";

// Shared Components
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";

import orbitService from "../../../services/orbit-service";
import styleSheet from "../style.module.scss";
import SySolarSystem from "../../../../../shared/components/sy-solar-system";
import LoadingScreen from "../../loading-screen";

import {
  getOrbitDetails,
  setAdminStuff,
  setHoverPlanet,
  setMaps,
  setSelectOrbit,
} from "../../../../../feature/orbit-slice";
import {
  getLoadingDetails,
  setFetchLoading,
  setloading,
} from "../../../../../feature/loading-slice";

const AppOrbitList = () => {
  const orbitInfo = useSelector(getOrbitDetails);
  const loadingSlice = useSelector(getLoadingDetails);
  const [orbitDetails, setOrbitDetails] = useState<any[]>([]);
  const [isFadingOut, setIsFadingOut] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();


  const { mutate: fetchGalaxy, isPending: galaxyLoading } = useMutation({
    mutationFn: orbitService.getGalaxy,
    onSuccess: (data) => setOrbitDetails(data?.data?.list ?? []),
  });


  const handleOrbitSelect = useCallback(
    (orbit: any) => {
      dispatch(setSelectOrbit(orbit.orb_id));
      setIsFadingOut(true);
      dispatch(setloading(true));
      const timeout = setTimeout(() => {
        navigate({
          pathname: "/orbit",
          search: `?id=${orbit.orb_id}&map=0&fr=list`,
        });
      }, 200);

      return () => clearTimeout(timeout);
    },
    [dispatch, navigate]
  );


  useEffect(() => {
    fetchGalaxy({
      pagination: { index: 0, size: 12 },
      search: orbitInfo.orbitSearch,
    });
  }, [orbitInfo.orbitSearch, fetchGalaxy]);


  useEffect(() => {
    dispatch(setFetchLoading(galaxyLoading));
  }, [galaxyLoading, dispatch]);

  useEffect(() => {
  dispatch(setSelectOrbit(null));
  dispatch(setMaps(0));
  dispatch(setAdminStuff(null));
  dispatch(setHoverPlanet(null));
  
  }, []);



  return (
    <>
      <div className={`${styleSheet.list_container} position-relative sy-scroll-x sy-scroll-y`}>
        <div className="row container-fluid d-flex justify-content-center mt-5">
          {orbitDetails.map((orbit) => (
            <div
              key={orbit.orb_id}
              className={`${styleSheet.list} ${
                isFadingOut ? "slide_out_top" : "slide_in_bottom"
              } col-3 mt-5 ms-4`}
              onClick={() => handleOrbitSelect(orbit)}
            >
              <div className="d-flex justify-content-center">
                <h4 className="text-white pointer ellipsis">
                  {orbit.orb_name || "orbit"}
                </h4>
              </div>

              <SySolarSystem
                layout={orbit?.planets}
                planetOnclick={() => handleOrbitSelect(orbit)}
              />
            </div>
          ))}
        </div>
      </div>

      {loadingSlice.loading && <LoadingScreen mode="orbitLoading" />}
    </>
  );
};

export default AppOrbitList;
